const afterRecordMap = new WeakMap();
/**
 * @description 项目下路由列表
 * @type {import("vue-router").RouteRecord[]}
 */
export default [
  {
    path: "/project",
    name: "project",
    component: () => import("@/CommonDP/pages/mainMg/project/project"),
    async beforeEnter(to, _from, next) {
      const store = require("@/store/index").default;
      // fix-bug: 路由导航时,如果更新路由树,会导致导航失败
      // fix: 先将获取项目权限的方法后置,等到路由导航结束的时候(全局路由afterEach时)再调用
      const getModuleProjectList = () => store.dispatch("getModuleProjectList");
      afterRecordMap.set(to, getModuleProjectList);
      next();
    },
    meta: {
      after: afterRecordMap,
      routeName: "项目",
      icon: require("@/CommonDP/assets/settings/project.svg")
    },

    children: [
      {
        path: "/project-XtDesign",
        name: "XtDesign",
        component: () => import("@/CommonDP/pages/mainMg/project/document/index.vue"),
        meta: {
          routeName: "文档",
          prouteName: "文档",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/XtDesign.svg"),
          icon2: require("@/CommonDP/assets/settings/XtDesign.svg")
        }
      },
      {
        path: "/project-checkRegion",
        name: "checkRegion",
        component: () => import("@/CommonDP/pages/mainMg/project/checkRegion/index.vue"),
        meta: {
          routeName: "校审区",
          prouteName: "校审区",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/checkRegion.svg"),
          icon2: require("@/CommonDP/assets/settings/checkRegion.svg")
        }
      },
      {
        path: "/project-issueMg",
        name: "issueMg",
        component: () => import("@/CommonDP/pages/mainMg/project/issueMg/issueMg.vue"),
        meta: {
          routeName: "问题",
          prouteName: "问题",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/prjpro.svg"),
          icon2: require("@/CommonDP/assets/settings/prjpro.svg")
        }
      },
      {
        path: "/project-taskList",
        name: "taskList",
        component: () => import("@/CommonDP/pages/mainMg/project/task/list.vue"),
        meta: {
          routeName: "计划",
          prouteName: "计划",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/task.svg"),
          icon2: require("@/CommonDP/assets/settings/task.svg")
        }
      },
      {
        path: "/project-taskDetail",
        name: "taskDetail",
        component: () => import("@/CommonDP/pages/mainMg/project/task/taskDetail.vue"),
        meta: {
          routeName: "",
          prouteName: "计划",
          pname: "项目"
        },
        props: route => ({
          task: route.query.task,
          showType: route.query.showType
        })
      },
      {
        path: "/project-approval",
        name: "projectApproval",
        meta: {
          routeName: "审批",
          prouteName: "审批",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/approval.svg"),
          icon2: require("@/CommonDP/assets/settings/approval.svg")
        },
        component: () => import("@/CommonDP/pages/mainMg/approval/projectIndex.vue")
      },
      {
        path: "/project-personPlan",
        name: "personPlan",
        component: () => import("@/CommonDP/pages/mainMg/project/personPlan/personPlan.vue"),
        meta: {
          routeName: "成员",
          prouteName: "成员",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/personPlan.svg"),
          icon2: require("@/CommonDP/assets/settings/personPlan.svg")
        }
      },
      {
        path: "/project-invitePersonPlan",
        name: "invitePersonPlan",
        component: () => import("@/CommonDP/pages/mainMg/project/personPlan/invitePersonPlan.vue"),
        meta: {
          routeName: "成员",
          prouteName: "成员",
          pname: "项目",
          permissionKey: "personPlan"
        }
      }, // 邀请人员
      {
        path: "/project-childPersonPlan",
        name: "childPersonPlan",
        component: () =>
          import(
            "@/CommonDP/pages/mainMg/project/childPersonPlan/childPersonPlan.vue"
          ),
        meta: {
          routeName: "成员",
          prouteName: "成员",
          pname: "项目",
          permissionKey: "personPlan"
        }
      }, // 子项成员
      {
        path: "/project-setup",
        name: "setup",
        component: () => import("@/CommonDP/pages/mainMg/project/plan/plan.vue"),
        meta: {
          routeName: "策划",
          prouteName: "策划",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/cehua.svg"),
          icon2: require("@/CommonDP/assets/settings/cehua.svg")
        },
        children: [
          {
            path: "/project-directory-maintenance",
            name: "directoryMaintenance",
            component: () => import("@/CommonDP/pages/mainMg/project/plan/components/directoryMaintain/index.vue"),
            meta: {
              routeName: "关键目录维护",
              prouteName: "策划",
              pname: "项目"
            }
          },
          {
            path: "/project-role-permission",
            name: "rolePermission",
            component: () => import("@/CommonDP/pages/mainMg/project/plan/components/docPermission.vue"),
            meta: {
              routeName: "角色权限管理",
              prouteName: "策划",
              pname: "项目",
              icon: require("@/CommonDP/assets/settings/XtDesign2.png")
            }
          },
          {
            path: "/project-revit-banbenshezhi",
            name: "revitBanbenshezhi",
            component: () => import("@/CommonDP/pages/mainMg/project/plan/components/revitBanbenshezhi/index.vue"),
            meta: {
              routeName: "Revit版本设置",
              prouteName: "策划",
              pname: "项目",
              icon: require("@/CommonDP/assets/settings/XtDesign2.png")
            }
          },
          {
            path: "/project-yangbanshezhi",
            name: "yangbanshezhi",
            component: () => import("@/CommonDP/pages/mainMg/project/plan/components/yangbanshezhi/index.vue"),
            meta: {
              routeName: "样板设置",
              prouteName: "策划",
              pname: "项目",
              icon: require("@/CommonDP/assets/settings/XtDesign2.png")
            }
          },
          {
            path: "/project-banbenshezhi",
            name: "banbenshezhi",
            component: () => import("@/CommonDP/pages/mainMg/project/plan/components/banbenshezhi/index.vue"),
            meta: {
              routeName: "标准图框设置",
              prouteName: "策划",
              pname: "项目",
              icon: require("@/CommonDP/assets/settings/XtDesign2.png")
            }
          }
        ]
      },
      {
        path: "/noproject",
        name: "noproject",
        component: () => import("@/CommonDP/pages/mainMg/project/noproject.vue"),
        meta: {
          routeName: "暂无项目",
          prouteName: "暂无项目",
          pname: "项目"
        }
      },
      {
        path: "/nopermisson",
        name: "nopermisson",
        component: () => import("@/CommonDP/pages/mainMg/project/nopermisson.vue"),
        meta: {
          routeName: "暂无权限",
          prouteName: "暂无权限",
          pname: "项目"
        }
      },
      {
        path: "/project-prjNotice",
        name: "prjNotice",
        component: () => import("@/CommonDP/pages/mainMg/project/prjNotice/prjNotice.vue"),
        meta: {
          routeName: "公告",
          prouteName: "公告",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/notice.svg"),
          icon2: require("@/CommonDP/assets/settings/notice.svg")
        }
      },
      {
        path: "/project-projectBoard", // 项目看板
        name: "projectBoard",
        component: () => import("@/CommonDP/pages/mainMg/project/projectBoard/projectBoard.vue"),
        meta: {
          routeName: "看板",
          prouteName: "看板",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/prjBoard.svg"),
          icon2: require("@/CommonDP/assets/settings/prjBoard.svg")
        }
      },
      {
        path: "/project-sheetSet",
        name: "sheetSet",
        component: () => import("@/CommonDP/pages/mainMg/project/sheetSet/sheetSet.vue"),
        meta: {
          routeName: "图纸集",
          prouteName: "图纸集",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/sheetSet.svg"),
          icon2: require("@/CommonDP/assets/settings/sheetSet.svg")
        }
      },
      {
        path: "/project-webPdfSign",
        name: "projectWebPdfSign",
        component: () => import("@/CommonDP/pages/mainMg/project/webPdfSign/webPdfSign.vue"),
        meta: {
          routeName: "pdf签章",
          prouteName: "pdf签章",
          pname: "项目",
          icon1: require("@/CommonDP/assets/settings/webPdfSign.svg"),
          icon2: require("@/CommonDP/assets/settings/webPdfSign.svg")
        }
      }
    ]
  }
];
